import { Form } from "antd";
import UploadAvatar from "component/upload_avatar";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const InfoAvatar = () => {
  // -------------------------- VAR -----------------------------
  const form = Form?.useFormInstance();
  const base64 = Form?.useWatch("base64", form) || null;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  const handleChange = (base64) => {
    form?.setFieldValue("base64", base64);
  };

  console.log({ base64 });
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <div className="flex flex-col gap-2">
      <UploadAvatar image={base64} onChange={handleChange} />
      <Form.Item name="base64" hidden />
    </div>
  );
};
export default InfoAvatar;
